import Content from "components/Content";
import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { ExtendedNextPage } from "types/pages";
import Script from "next/script";

import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import styles from "./styles.module.scss";

const FAQ: ExtendedNextPage = () => {
  const { query, isReady } = useRouter();
  const { gh_jid: jobUID }: { gh_jid?: string } = query;
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (isReady && jobUID && globalThis.window?.Grnhse?.Iframe && !loaded) {
      globalThis.window.Grnhse.Iframe.load(parseInt(jobUID, 10));
      setLoaded(true);
    }
  }, [isReady, jobUID, loaded]);

  return (
    <div className={styles.container}>
      <Head>
        <title>Apply</title>
        <meta name="description" content="Apply to Humming Homes!" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      {isReady && (
        <Script
          id="greenhouse"
          src="https://boards.greenhouse.io/embed/job_board/js?for=humminghomes"
          onLoad={() => {
            if (jobUID) {
              window.Grnhse.Iframe.load(parseInt(jobUID, 10));
              setLoaded(true);
            }
          }}
        />
      )}
      <Content>
        <div className={styles.gh} id="grnhse_app" />
      </Content>
    </div>
  );
};

FAQ.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default FAQ;
